import { observer } from 'mobx-react';
import * as React from 'react';
import LearningCollectionStore from '../../../Store';
import { ProductLicensesResource } from '../../../../Types';
import ActiveProductLicense from './ActiveProductLicense';
import InActiveProductLicense from './InActiveProductLicense';
import { fromEmpty } from 'maybeasy';
import NoActiveProductLicenses from './NoActiveProductLicenses';
import { filterOnlySelectedInactiveLicense } from './ActiveProductLicense/Selection';
import { emptyFragment } from '../../../../../../EmptyFragment';

interface Props {
  store: LearningCollectionStore;
  productLicensesResource: ProductLicensesResource;
}

const Left: React.FC<Props> = ({ store, productLicensesResource }) => {
  const { activeProductLicenses, inactiveProductLicenses } = productLicensesResource.payload;

  return (
    <div
      className="flex flex-col basis-full pt-8 lg:basis-3/5"
      data-intercom-target="choose-product-license-list"
    >
      {fromEmpty(activeProductLicenses)
        .map((activeProductLicenses) => (
          <>
            {activeProductLicenses.map((activeProductLicense, index) => (
              <ActiveProductLicense
                key={activeProductLicense.payload.id}
                activeProductLicense={activeProductLicense}
                store={store}
                dataIntercomTarget={
                  index === 0 ? 'first-active-product-license' : 'active-product-license'
                }
              />
            ))}
          </>
        ))
        .getOrElse(() => (
          <NoActiveProductLicenses />
        ))}
      {filterOnlySelectedInactiveLicense(store, inactiveProductLicenses)
        .map((inactiveLicense) => (
          <InActiveProductLicense
            key={inactiveLicense.first.payload.id}
            store={store}
            inactiveProductLicenses={inactiveLicense.first}
            dataIntercomTarget="inactive-product-license"
          />
        ))
        .getOrElse(emptyFragment)}
    </div>
  );
};

export default observer(Left);
